import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "h-pt-30 h-flex-center h-flex-dir-column" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FwDatepicker = _resolveComponent("FwDatepicker")!
  const _component_FwButton = _resolveComponent("FwButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_FwDatepicker, {
      modelValue: _ctx.localDate,
      name: "datepicker",
      class: "h-mv-20",
      propsRange: false,
      selectMode: false,
      pickerStyle: "static",
      propsLang: `${_ctx.$i18n.locale}`,
      hideIcon: true,
      showWeeksNumbers: true,
      reservedSlots: _ctx.eventsSlots,
      hideInput: true,
      reservedSlotsColor: "green",
      onChangeCalendarMonth: _ctx.changeCalendarMonthHandler,
      onSelectDate: _ctx.updateDatesHandler
    }, null, 8, ["modelValue", "propsLang", "reservedSlots", "onChangeCalendarMonth", "onSelectDate"]),
    _createVNode(_component_FwButton, {
      size: "little",
      borderRadiusType: "small-border",
      class: "h-mt-50 h-min-width-120",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit("showChoosePopup")))
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.$t('BUTTON.ADD')), 1)
      ]),
      _: 1
    }),
    _createVNode(_component_FwButton, {
      size: "little",
      borderRadiusType: "small-border",
      class: "h-mt-20 h-min-width-120",
      onClick: _ctx.refresh
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.$t('BUTTON.REFRESH')), 1)
      ]),
      _: 1
    }, 8, ["onClick"])
  ]))
}